/* eslint-disable no-unused-vars */
import styled from 'styled-components';
import { Palette } from 'config';

export const Header = styled.header`
  display: grid;
  grid-template-columns: auto 1fr auto;
  margin-top: calc(77px + 48px);
  margin-bottom: 48px;
  align-items: center;
  column-gap: 20px;
`;

export const Title = styled.h2`
  color: ${Palette.PrimaryGray._900};
  font-size: 40px;
  font-style: normal;
  font-weight: 700;
  line-height: 48px;
  letter-spacing: -0.8px;
`;

export const Box = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ gap }) => gap && `${gap}px`};
  justify-self: end;
`;

export const CalendarBox = styled.div`
  display: flex;
  align-items: center;
  justify-self: center;
`;

export const CreateCampaignGroup = styled.div`
  display: flex;
  align-items: stretch;
`;

export const AiAssistantButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 14px;
  border: none;
  border-left: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 0 4px 4px 0;
  background-color: #f0b44b;
  color: #2d6be6;
  cursor: pointer;
  transition: transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1), background-color 0.15s ease;
  box-shadow: 0px 2px 2px rgba(28, 53, 106, 0.05);

  svg {
    width: 28px;
    height: 28px;
  }

  &:hover {
    background-color: #e5a53c;
    transform: scale(1.18);
  }

  &:active {
    background-color: #f0b44b;
    box-shadow: 0px 0px 0px 3px rgba(240, 180, 75, 0.3);
    color: #1d4fba;
  }
`;
